import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {AuthService} from '../../core/http/auth/auth.service';
import {UserCacheService} from '../../core/user/user-cache.service';
import {UserDetails} from 'src/app/core/http/auth/model/user';
import {OutletCacheService} from '../../core/outlet-cache/outlet-cache.service';
import {RedirectUrlService} from '../../core/helper/redirect-url.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private userService: UserCacheService,
    private outletService: OutletCacheService,
    private redirectUrlService: RedirectUrlService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.fetchUserData();
  }

  private fetchUserData(): void {
    this.authService.authenticate().subscribe((userDetails: UserDetails) => {
      if (userDetails != null) {
        this.userService.setUser(userDetails);
        this.outletService.setOutlets(userDetails.outlets);

        const language = userDetails.languageIso ? userDetails.languageIso.substring(0, 2) : 'en';
        //back to whatever page was asked for before the login, query params included
        const requestedUrl = this.redirectUrlService.consume() || '/dashboard';

        //a full page load, the locale is part of the path and is served as a separate build
        location.href = '/' + language + requestedUrl;
        return;
      }
      this.router.navigate(['dashboard']);
    });

  }
}
